// extracted by mini-css-extract-plugin
module.exports = {"upload":"Upload_upload__KsRPc","input":"Upload_input__2l3B5"};